module.exports = __webpack_public_path__ + "static/media/x.958d4939.svg";